module.exports = __webpack_public_path__ + "img/up-down-left-right.39ed2d9b.svg";